import { createSelector } from 'reselect';

import getInitialValue from '@r1-frontend/bp42/selectors/getInitialValue';
import getIsLoading from '@r1-frontend/bp42/selectors/getIsLoading';
import getPackageName from '@r1-frontend/bp42/selectors/getPackageName';
import getProducts from '@r1-frontend/bp42/selectors/getProducts';
import getStartedTyping from '@r1-frontend/bp42/selectors/getStartedTyping';
import getViewDetails from '@r1-frontend/bp42/selectors/getViewDetails';
import isFormValid from '@r1-frontend/bp42/selectors/isFormValid';
import isNeedToShowSpecOffer from '@r1-frontend/bp42/selectors/isNeedToShowSpecOffer';

const selectDataForCallbackForm = createSelector(
    [
        getProducts,
        getPackageName,
        getViewDetails,
        isNeedToShowSpecOffer,
        getInitialValue,
        getStartedTyping,
        isFormValid,
        getIsLoading,
    ], (
        products,
        packageName,
        viewDetails,
        needToShowSpecOffer,
        initialValue,
        isStartedTyping,
        formValid,
        isLoading,
    ) => ({
        packageName,
        products,
        viewDetails,
        needToShowSpecOffer,
        initialValue,
        isStartedTyping,
        isFormValid: formValid,
        isLoading,
    }),
);

export default selectDataForCallbackForm;
